import { create } from 'jss'
import { jssPreset } from '@material-ui/core/styles'

export const jss = create({
    plugins: jssPreset().plugins,
})
